/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createBitNot } from '../../factoriesAny.js';
export var bitNotDependencies = {
  typedDependencies: typedDependencies,
  createBitNot: createBitNot
};